import { Component, OnInit } from "@angular/core";
import { AnalyticsTracker } from "../../../../utils/AnalyticsTracker";

@Component({
    selector: 'app-poster',
    templateUrl: './poster.component.html',
    styleUrls: ['./poster.component.scss'],
})
export class PosterComponent implements OnInit {
    constructor(public analyticsTracker: AnalyticsTracker) {}
    ngOnInit(): void {
        
    }
}